<template>
  <v-navigation-drawer v-model="drawer" temporary app>
    <v-toolbar flat class="white primary--text">
      <app-drawer-toggle-button color="primary" icon="fa fa-times" />
      <v-toolbar-title class="headline">Menu</v-toolbar-title>
    </v-toolbar>
<!--    <v-card flat color="secondary">-->
<!--      <v-layout row>-->
<!--        <v-flex xs5>-->
<!--          <v-avatar size="100px" class="ma-3">-->
<!--            <v-img :src="avatar"></v-img>-->
<!--          </v-avatar>-->
<!--        </v-flex>-->
<!--        <v-flex xs7>-->
<!--          <v-layout align-end column>-->
<!--            <v-card-title primary-title>-->
<!--              <div class="headline accent&#45;&#45;text">David Pavel</div>-->
<!--            </v-card-title>-->
<!--            <v-btn color="primary" flat>Odhlásit</v-btn>-->
<!--          </v-layout>-->
<!--        </v-flex>-->
<!--      </v-layout>-->
<!--    </v-card>-->
    <v-list subheader v-for="group in groups" :key="group.title">
      <v-subheader class="accent--text">{{ group.title }}</v-subheader>
      <v-list-tile
        v-for="item in group.items"
        :key="item.title"
        avatar
        :to="item.to"
      >
        <v-list-tile-content class="primary--text ml-3">
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { TOGGLE_DRAWER } from "../action-types";
import AppDrawerToggleButton from "./AppDrawerToggleButton";
import avatar from "@/assets/images/avatar.jpg";

export default {
  name: "AppDrawer",
  components: { AppDrawerToggleButton },
  data() {
    return {
      avatar,
      groups: [
        {
          title: "Recepty",
          items: [
            {
              title: "Seznam receptů",
              to: "/recipes"
            },
            {
              title: "Vyhledat recept",
              to: "/search"
            },
            {
              title: "Přidat recept",
              to: "/add-recipe"
            }
          ]
        },
        {
          title: "Nákup",
          items: [
            {
              title: "Nákupní seznamy",
              to: "/shopping-lists"
            },
            {
              title: "Vyhledat recept",
              to: "/add-shopping-list"
            }
          ]
        }
      ]
    };
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(value) {
        this.$store.dispatch(TOGGLE_DRAWER, value);
      }
    }
  }
};
</script>

<style>
.user-info {
  padding: 1rem;
}
</style>
